// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"controller_Sidebar__3sGCZ","Links":"controller_Links__3pQtZ","Link":"controller_Link__27iSd","Main":"controller_Main__3aL2C"};